// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useRef, useState } from "react";
import * as Yup from "yup";
import { data, Link, useNavigate, useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { LightModeOutlined } from "@mui/icons-material";
import { parentController } from "../../_api/controllers/parent.controller.ts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { studentControler } from "../../_api/controllers/student.controller.ts";

const NewStudent: React.FC = () => {
  // État pour les onglets et le modal
  const [activeTab, setActiveTab] = useState("informations");
  const [showAddParentForm, setShowAddParentForm] = useState(false);
  const [formData, setFormData] = useState({
    // Informations personnelles
    photo: "",
    nom: "",
    postnom: "",
    prenom: "",
    genre: "",
    lieuNaissance: "",
    dateNaissance: "",
    uid: "12345678",
    parent_id: "",
    // numeroEtudiant: "STD-2025-" + Math.floor(1000 + Math.random() * 9000),
    // Coordonnées
    adresse: {
      avenue: "",
      quartier: "",
      commune: "",
      ville: "",
      telephone: "",
    },
    contacts: {
      type: "",
      nom: "",
      postnom: "",
      prenom: "",
      genre: "",
      avenue: "",
      quartier: "",
      commune: "",
      ville: "",
      telephone: "",
      email: "",
      profession: "",
    },
    // email: "",
    // adresseSecondaire: {
    //   rue: "",
    //   codePostal: "",
    //   ville: "",
    // },
    // Informations scolaires
    // classe: "",
    // anneeScolaire: "2025 - 2026",
    // options: [],
    // regime: "",
    // dateEntree: "",
    // Contacts d'urgence
  });

  const [notification, setNotification] = useState<any>(null); // { message, type }

  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  //Onchange Adress
  const handleAdresseChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      adresse: { ...prev.adresse, [name]: value },
    }));
  };
  //Onchange A
  const handleContactsChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      contacts: { ...prev.contacts, [name]: value },
    }));
  };

  // État pour la gestion du drag and drop de la photo
  const [dragActive, setDragActive] = useState<boolean>(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  // Référence pour l'input de fichier
  const fileInputRef = useRef<HTMLInputElement>(null);
  // Fonction pour gérer le changement de champ
  // const handleChange = (
  //   e: React.ChangeEvent<
  //     HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
  //   >,
  //   section?: string,
  //   field?: string,
  //   index?: number
  // ) => {
  //   const { name, value } = e.target;
  //   if (section && field) {
  //     // Pour les champs imbriqués comme adresse.rue
  //     setFormData((prev) => ({
  //       ...prev,
  //       [section]: {
  //         ...prev[section as keyof typeof prev],
  //         [field]: value,
  //       },
  //     }));
  //   } else if (section === "contacts" && typeof index === "number") {
  //     // Pour les contacts d'urgence
  //     const updatedContacts = [...formData.contacts];
  //     updatedContacts[index] = {
  //       ...updatedContacts[index],
  //       [name]: value,
  //     };
  //     setFormData((prev) => ({
  //       ...prev,
  //       contacts: updatedContacts,
  //     }));
  //   } else {
  //     // Pour les champs simples
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };
  // Fonction pour ajouter un contact d'urgence
  //   const addContact = () => {
  //     setFormData((prev) => ({
  //       ...prev,
  //       contacts: [
  //         ...prev.contacts,
  //         {
  //           type: "",
  //           nom: "",
  //           prenom: "",
  //           telephone: "",
  //           email: "",
  //           adresse: "",
  //           profession: "",
  //         },
  //       ],
  //     }));
  //   };
  // Fonction pour supprimer un contact d'urgence
  // const removeContact = (index: number) => {
  //   if (formData.contacts.length > 1) {
  //     const updatedContacts = [...formData.contacts];
  //     updatedContacts.splice(index, 1);
  //     setFormData((prev) => ({
  //       ...prev,
  //       contacts: updatedContacts,
  //     }));
  //   }
  // };
  // Fonctions pour la gestion du drag and drop
  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };
  const handleFile = (file: File) => {
    // Vérifier si le fichier est une image
    if (!file.type.match("image.*")) {
      alert("Veuillez sélectionner une image");
      return;
    }
    // Créer une URL pour prévisualiser l'image
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    // Mettre à jour l'état avec le fichier
    setFormData((prev) => ({
      ...prev,
      photo: file.name,
    }));
  };
  const onButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // État pour le mode sombre
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  // Fonction pour basculer le mode sombre
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // This goes back to the previous page
  };

  // This regular expression checks for:
  // 1. A "+" followed by a country code (e.g., +1, +44, etc.)
  // 2. Then, 10 digits for the phone number (or adjust the length to your requirements).
  const phoneNumberSchema = Yup.string().matches(
    /^\+(\d{1,3})\d{7,14}$/, // Example: +1 followed by 10-15 digits
    "Entrer l'indicatif de pays suivi d'un numéro valide"
  );

  // Example usage in a form:
  const validatePhoneNumber = async (phoneNumber: any, nextTab: string) => {
    if (
      !!formData.adresse.telephone.trim() ||
      !!formData.contacts.telephone.trim()
    ) {
      try {
        await phoneNumberSchema.validate(phoneNumber);
        setActiveTab(nextTab);
        console.log("Phone number is valid!");
      } catch (error: any) {
        console.error("Validation error:", error.message);
        return showNotification(error.message, "error");
      }
    }
  };

  const queryClient = useQueryClient();
  //fetch anne parents
  const { data: parentData } = useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });

  const parentsDataArr = parentData?.data || [];

  const mutationCreateParent = useMutation({
    mutationFn: () =>
      parentController.create({
        nom: formData.contacts.nom,
        postnom: formData.contacts.postnom,
        prenom: formData.contacts.prenom,
        sexe: formData.contacts.genre,
        ville: formData.contacts.ville,
        commune: formData.contacts.commune,
        quartier: formData.contacts.quartier,
        avenue: formData.contacts.avenue,
        telephone: formData.contacts.telephone,
        email: formData.contacts.email,
        profession: formData.contacts.profession,
        type: formData.contacts.type,
      }),

    onSuccess: (data) => {
      // data.data;
      const parentId = data?.data?.[0]?.id;

      if (!parentId) {
        return showNotification(
          "Impossible de récupérer les informations du parent",
          "error"
        );
      }
      //student mutation
      mutationCreateStudentMeth1.mutate(parentId);
    },

    onError: (err) => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  //create student sequetially with the id parent generated after creation of parent
  const mutationCreateStudentMeth1 = useMutation({
    mutationFn: (idParent) =>
      studentControler.create({
        nom: formData.nom,
        postnom: formData.postnom,
        prenom: formData.prenom,
        sexe: formData.genre,
        ville: formData.adresse.ville,
        commune: formData.adresse.commune,
        quartier: formData.adresse.quartier,
        avenue: formData.adresse.avenue,
        telephone: formData.adresse.telephone,
        uid: "12345678",
        date_naissance: formData.dateNaissance,
        lieu_naissance: formData.lieuNaissance,
        parent_id: idParent,
      }),

    onSuccess: (data) => {
      // data.data;
      showNotification("Inscription effectuée avec success", "success");
      queryClient.invalidateQueries({ queryKey: ["students"] });
      queryClient.invalidateQueries({ queryKey: ["parents"] });
    },

    onError: (err) => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  //create student with the existing parent
  const mutationCreateStudentMeth2 = useMutation({
    mutationFn: () =>
      studentControler.create({
        nom: formData.nom,
        postnom: formData.postnom,
        prenom: formData.prenom,
        sexe: formData.genre,
        ville: formData.adresse.ville,
        commune: formData.adresse.commune,
        quartier: formData.adresse.quartier,
        avenue: formData.adresse.avenue,
        telephone: formData.adresse.telephone,
        uid: "12345678",
        date_naissance: formData.dateNaissance,
        lieu_naissance: formData.lieuNaissance,
        parent_id: formData.parent_id,
      }),

    onSuccess: (data) => {
      // data.data;
      showNotification("Inscription effectuée avec success", "success");
      queryClient.invalidateQueries({ queryKey: ["students"] });
      queryClient.invalidateQueries({ queryKey: ["parents"] });
    },

    onError: (error) => {
      console.log("============");
      console.log(error);
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const handleCreateStudentAndParent = () => {
    mutationCreateParent.mutate();
  };
  const handleCreateStudent = () => {
    mutationCreateStudentMeth2.mutate();
  };
  return (
    <div className="ml-60 w-full">
      {/* Header */}
      <header
        className={`fixed top-0 left-60 right-0 z-50 py-4 px-6 flex items-center justify-between border-b border-solid ${
          isDarkMode
            ? "border-gray-700 bg-[#0D1117]"
            : "border-gray-200 bg-white"
        }`}
      >
        <div className="flex items-center">
          <button
            onClick={goBack}
            className={`flex items-center px-3 py-2 rounded-md ${
              isDarkMode
                ? "bg-[#161B22] hover:bg-gray-700"
                : "bg-gray-100 hover:bg-gray-200"
            } !rounded-button whitespace-nowrap cursor-pointer`}
          >
            <i className="fas fa-arrow-left mr-2"></i>
            <span>Retour à la liste</span>
          </button>
          <div className="ml-4">
            <span className="text-sm text-gray-500"></span>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleDarkMode}
            className="p-2 rounded-full !rounded-button cursor-pointer whitespace-nowrap"
          >
            {isDarkMode ? (
              <LightModeOutlined className="text-yellow-400" />
            ) : (
              <i className="fas fa-moon"></i>
            )}
          </button>
          <button className="p-2 rounded-full !rounded-button cursor-pointer whitespace-nowrap">
            <i className="fas fa-bell"></i>
          </button>
          <button
            className={`w-8 h-8 rounded-full flex items-center justify-center !rounded-button cursor-pointer whitespace-nowrap ${
              isDarkMode ? "bg-gray-700" : "bg-gray-300"
            }`}
          >
            <span>A</span>
          </button>
        </div>
      </header>

      <div className="p-6 mt-16">
        <h1 className="text-2xl font-bold mb-1">Nouvelle Inscription</h1>
        <p className={`${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
          Enregistrement des informations de l'élève
        </p>
      </div>
      {/* Barre de progression */}
      <div className={`mx-auto px-4 sm:px-6 lg:px-8 `}>
        <div
          className={`text-sm font-medium rounded-lg p-6 border  ${
            isDarkMode
              ? "bg-[#161B22] border-gray-700 text-gray-400"
              : "bg-white border-gray-200 text-gray-700"
          }`}
        >
          <div className="flex justify-between mb-2">
            <span>Progression</span>
            <span>
              {activeTab === "informations"
                ? "1"
                : activeTab === "coordonnees"
                ? "2"
                : activeTab === "contacts" && "3"}
              /3
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-blue-600 h-2.5 rounded-full"
              style={{
                width:
                  activeTab === "informations"
                    ? "25%"
                    : activeTab === "coordonnees"
                    ? "50%"
                    : activeTab === "scolarite"
                    ? "75%"
                    : "100%",
              }}
            ></div>
          </div>
        </div>
      </div>
      {/* Contenu principal */}
      <main className="mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div
          className={` ${
            isDarkMode
              ? "bg-[#161B22] border-gray-700"
              : "bg-white border-gray-300"
          } rounded-lg p-6 border shadow`}
        >
          {/* Onglets */}
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <button
                onClick={() => setActiveTab("informations")}
                className={`py-4 px-6 border-b-2 font-medium text-sm ${
                  activeTab === "informations"
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-user mr-2"></i>
                Informations personnelles
              </button>
              <button
                onClick={() => {
                  const { ville, commune, quartier, avenue } = formData.adresse;
                  if (
                    !ville.trim() ||
                    !commune.trim() ||
                    !quartier.trim() ||
                    !avenue.trim()
                  ) {
                    return showNotification(
                      "Veuillez compléter tous les champs obligatoires",
                      "error"
                    );
                  } else {
                    setActiveTab("coordonnees");
                  }
                }}
                className={`py-4 px-6 border-b-2 font-medium text-sm ${
                  activeTab === "coordonnees"
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-map-marker-alt mr-2"></i>
                Coordonnées
              </button>
              {/* <button
                onClick={() => setActiveTab("scolarite")}
                className={`py-4 px-6 border-b-2 font-medium text-sm ${
                  activeTab === "scolarite"
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-school mr-2"></i>
                Informations scolaires
              </button> */}
              <button
                onClick={() => {
                  const { ville, commune, quartier, avenue, telephone } =
                    formData.adresse;

                  // Validate required fields
                  if (
                    !ville.trim() ||
                    !commune.trim() ||
                    !quartier.trim() ||
                    !avenue.trim()
                  ) {
                    return showNotification(
                      "Veuillez compléter tous les champs obligatoires",
                      "error"
                    );
                  }

                  // Validate telephone if provided
                  if (telephone.trim()) {
                    validatePhoneNumber(telephone, "contacts");
                  } else {
                    // No phone → proceed
                    setActiveTab("contacts");
                  }
                }}
                className={`py-4 px-6 border-b-2 font-medium text-sm ${
                  activeTab === "contacts"
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <i className="fas fa-phone-alt mr-2"></i>
                Contacts d'urgence
              </button>
            </nav>
          </div>
          {/* Formulaire */}
          {/* <form onSubmit={(e) => handleSubmit(e)} className="p-6"> */}
          <div className="p-6">
            {/* Informations personnelles */}
            {activeTab === "informations" && (
              <div className="space-y-6">
                <h2
                  className={`text-xl font-semibold  ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Informations personnelles
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  {/* Photo */}
                  <div className="md:col-span-1">
                    <label className={`block text-sm font-medium mb-2 }`}>
                      Photo de l'élève
                    </label>
                    <div
                      className={`mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md h-64 ${
                        dragActive
                          ? "border-blue-500 bg-blue-50"
                          : "border-gray-300"
                      } ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                      onDragEnter={handleDrag}
                      onDragOver={handleDrag}
                      onDragLeave={handleDrag}
                      onDrop={handleDrop}
                    >
                      {previewUrl ? (
                        <div className="w-full h-full flex items-center justify-center">
                          <img
                            src={previewUrl}
                            alt="Aperçu"
                            className="max-h-full max-w-full object-contain"
                          />
                        </div>
                      ) : (
                        <div className="space-y-1 text-center flex flex-col items-center justify-center w-full h-full">
                          <i className="fas fa-user-circle text-gray-400 text-6xl mb-4"></i>
                          <div className="flex text-sm text-gray-600">
                            <label
                              htmlFor="file-upload"
                              className={`relative cursor-pointer ${
                                isDarkMode ? "bg-[#0D1117]" : "bg-white"
                              }rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none`}
                            >
                              <span onClick={onButtonClick}>
                                Télécharger une photo
                              </span>
                              <input
                                id="file-upload"
                                name="file-upload"
                                type="file"
                                className="sr-only"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                accept="image/*"
                              />
                            </label>
                            <p className="pl-1">ou glisser-déposer</p>
                          </div>
                          <p className="text-xs text-gray-500">
                            PNG, JPG, GIF jusqu'à 10MB
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="md:col-span-2 space-y-6">
                    {/* Nom et prénom */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label
                          htmlFor="nom"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Nom <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="nom"
                          id="nom"
                          required
                          value={formData.nom}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              nom: e.target.value,
                            }));
                          }}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="prenom"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Post-Nom <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="postnom"
                          id="postnom"
                          required
                          value={formData.postnom}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              postnom: e.target.value,
                            }));
                          }}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>
                    </div>
                    {/* Date de naissance et genre */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label
                          htmlFor="prenom"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Prénom <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="prenom"
                          id="prenom"
                          required
                          value={formData.prenom}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              prenom: e.target.value,
                            }));
                          }}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>

                      <div>
                        <label
                          htmlFor="genre"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Genre
                        </label>
                        <select
                          id="genre"
                          name="genre"
                          value={formData.genre}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              genre: e.target.value,
                            }));
                          }}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        >
                          <option value="">Sélectionner</option>
                          <option value="M">Masculin</option>
                          <option value="F">Féminin</option>
                        </select>
                      </div>
                    </div>
                    {/* Date de naissance et numéro d'étudiant */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label
                          htmlFor="prenom"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Lieu de Naissance{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="lieuNaissance"
                          id="lieuNaissance"
                          required
                          value={formData.lieuNaissance}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              lieuNaissance: e.target.value,
                            }));
                          }}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>

                      <div>
                        <label
                          htmlFor="dateNaissance"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Date de naissance{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="date"
                          name="dateNaissance"
                          id="dateNaissance"
                          required
                          value={formData.dateNaissance}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              dateNaissance: e.target.value,
                            }));
                          }}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`fixed bottom-0 left-60 right-0 py-3 px-6 border-t ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700"
                      : "bg-white border-gray-200"
                  } flex justify-between items-center`}
                >
                  <div className="flex justify-end flex-1 space-x-3 items-center">
                    <Link
                      to={"/eleves"}
                      className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                    >
                      Annuler
                    </Link>
                    <button
                      type="button"
                      onClick={() => {
                        const {
                          nom,
                          postnom,
                          prenom,
                          genre,
                          lieuNaissance,
                          dateNaissance,
                        } = formData;
                        if (
                          !nom.trim() ||
                          !postnom.trim() ||
                          !prenom.trim() ||
                          !genre.trim() ||
                          !dateNaissance.trim() ||
                          !lieuNaissance.trim()
                        ) {
                          return showNotification(
                            "Veuillez compléter tous les champs obligatoires",
                            "error"
                          );
                        } else {
                          setActiveTab("coordonnees");
                        }
                      }}
                      className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                    >
                      Suivant
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* Coordonnées */}
            {activeTab === "coordonnees" && (
              <div className="space-y-6">
                <h2
                  className={`text-xl font-semibold  ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Coordonnées
                </h2>
                <div className="space-y-6">
                  <div>
                    <h3
                      className={`text-lg font-medium  ${
                        isDarkMode ? "text-gray-400" : "text-gray-600"
                      }`}
                    >
                      Adresse principale
                    </h3>
                    <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                      <div className="sm:col-span-6">
                        <label
                          htmlFor="avenue"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Avenue <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="avenue"
                          id="avenue"
                          required
                          value={formData.adresse.avenue}
                          onChange={handleAdresseChange}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>
                      <div className="sm:col-span-2">
                        <label
                          htmlFor="quartier"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Quartier <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="quartier"
                          id="quartier"
                          required
                          value={formData.adresse.quartier}
                          onChange={handleAdresseChange}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>
                      <div className="sm:col-span-4">
                        <label
                          htmlFor="commune"
                          className={`block text-sm font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Commune <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="commune"
                          id="commune"
                          required
                          value={formData.adresse.commune}
                          onChange={handleAdresseChange}
                          className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                            isDarkMode
                              ? "bg-[#0D1117] border-gray-700"
                              : "bg-gray-50 border-gray-200"
                          }`}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label
                        htmlFor="ville"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Ville <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        required
                        name="ville"
                        id="ville"
                        value={formData.adresse.ville}
                        onChange={handleAdresseChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="telephone"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Téléphone
                      </label>
                      <input
                        type="tel"
                        name="telephone"
                        id="telephone"
                        value={formData.adresse.telephone}
                        onChange={handleAdresseChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`fixed bottom-0 left-60 right-0 py-3 px-6 border-t ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700"
                      : "bg-white border-gray-200"
                  } flex justify-between items-center`}
                >
                  <button
                    type="button"
                    onClick={() => setActiveTab("informations")}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                  >
                    Précédent
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      //validate required filds
                      const { ville, commune, quartier, avenue } =
                        formData.adresse;
                      if (
                        !ville.trim() ||
                        !commune.trim() ||
                        !quartier.trim() ||
                        !avenue.trim()
                      ) {
                        return showNotification(
                          "Veuillez compléter tous les champs obligatoires",
                          "error"
                        );
                      }
                      //validate phone number structure
                      if (!!formData.adresse.telephone.trim()) {
                        validatePhoneNumber(
                          formData.adresse.telephone,
                          "contacts"
                        );
                      } else {
                        setActiveTab("contacts");
                      }
                    }}
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                  >
                    Suivant
                  </button>
                </div>
              </div>
            )}
            {/* Informations scolaires */}
            {/* {activeTab === "scolarite" && (
              <div className="space-y-6">
                <h2
                  className={`text-xl font-semibold  ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Informations scolaires
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="classe"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Classe <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="classe"
                      name="classe"
                      required
                      value={formData.classe}
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <option value="">Sélectionner une classe</option>
                      <option value="6A">6ème A</option>
                      <option value="6B">6ème B</option>
                      <option value="5A">5ème A</option>
                      <option value="5B">5ème B</option>
                      <option value="4A">4ème A</option>
                      <option value="4B">4ème B</option>
                      <option value="3A">3ème A</option>
                      <option value="3B">3ème B</option>
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor="anneeScolaire"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Année scolaire <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="anneeScolaire"
                      name="anneeScolaire"
                      required
                      value={formData.anneeScolaire}
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <option value="2025 - 2026">2025 - 2026</option>
                      <option value="2024 - 2025">2024 - 2025</option>
                      <option value="2023 - 2024">2023 - 2024</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Options / Spécialités
                  </label>
                  <div className="mt-2 space-y-2">
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="option1"
                          name="option1"
                          type="checkbox"
                          className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label
                          htmlFor="option1"
                          className={`font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Anglais renforcé
                        </label>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="option2"
                          name="option2"
                          type="checkbox"
                          className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label
                          htmlFor="option2"
                          className={`font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Section européenne
                        </label>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="option3"
                          name="option3"
                          type="checkbox"
                          className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label
                          htmlFor="option3"
                          className={`font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Latin
                        </label>
                      </div>
                    </div>
                    <div className="flex items-start">
                      <div className="flex items-center h-5">
                        <input
                          id="option4"
                          name="option4"
                          type="checkbox"
                          className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                      </div>
                      <div className="ml-3 text-sm">
                        <label
                          htmlFor="option4"
                          className={`font-medium ${
                            isDarkMode ? "text-gray-400" : "text-600"
                          } `}
                        >
                          Option sportive
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="regime"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Régime <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="regime"
                      name="regime"
                      required
                      value={formData.regime}
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <option value="">Sélectionner</option>
                      <option value="externe">Externe</option>
                      <option value="demi-pension">Demi-pension</option>
                      <option value="interne">Interne</option>
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor="dateEntree"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Date d'entrée <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      name="dateEntree"
                      id="dateEntree"
                      required
                      value={formData.dateEntree}
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    />
                  </div>
                </div>
                <div
                  className={`fixed bottom-0 left-60 right-0 py-3 px-6 border-t ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700"
                      : "bg-white border-gray-200"
                  } flex justify-between items-center`}
                >
                  <button
                    type="button"
                    onClick={() => setActiveTab("coordonnees")}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                  >
                    Précédent
                  </button>
                  <button
                    type="button"
                    onClick={() => setActiveTab("contacts")}
                    className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                  >
                    Suivant
                  </button>
                </div>
              </div>
            )} */}
            {/* Contacts d'urgence */}
            {activeTab === "contacts" && (
              <div className="space-y-6">
                <h2
                  className={`text-xl font-semibold  ${
                    isDarkMode ? "text-gray-400" : "text-gray-600"
                  }`}
                >
                  Contacts d'urgence (parents/tuteurs)
                </h2>
                <div
                  className={`p-4 rounded-lg border mb-6  ${
                    isDarkMode
                      ? "bg-[#161B22] border-gray-700 "
                      : "bg-white border-gray-200"
                  }`}
                >
                  {!showAddParentForm && (
                    <div className="space-y-6">
                      <div>
                        <h3
                          className={`text-lg font-medium  ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          Parents
                        </h3>
                        <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                          <div className="sm:col-span-4">
                            <label
                              htmlFor="idParent"
                              className={`block text-sm font-medium ${
                                isDarkMode ? "text-gray-400" : "text-600"
                              } `}
                            >
                              sélectionner parent{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              name="idParent"
                              id="idParent"
                              required
                              value={formData.parent_id}
                              onChange={(e) =>
                                setFormData((prev) => ({
                                  ...prev,
                                  parent_id: e.target.value,
                                }))
                              }
                              className={`mt-1 block w-full h-12 border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700"
                                  : "bg-gray-50 border-gray-200"
                              }`}
                            >
                              <option value="">Sélectionner parent</option>
                              {parentsDataArr.map((item) => (
                                <option
                                  key={item.parent_id}
                                  value={item.parent_id}
                                >
                                  {item.nom.toUpperCase()}{" "}
                                  {item.postnom.toUpperCase()}{" "}
                                  {item.prenom.toUpperCase()}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="sm:col-span-1">
                            {/* <label
                            hidden
                            htmlFor="button"
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            button <span className="text-red-500">*</span>
                          </label> */}
                            <button
                              onClick={() => setShowAddParentForm(true)}
                              className="px-4 py-3 flex mt-6 gap-2 items-center border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                            >
                              <i className="fas fa-add"></i>
                              Nouveau parent
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {showAddParentForm && (
                    <>
                      <div className="flex justify-between items-center mb-4">
                        <h3
                          className={`text-lg font-medium  ${
                            isDarkMode ? "text-gray-400" : "text-gray-600"
                          }`}
                        >
                          {/* Contact {index + 1} */}
                          Contact
                          <span className="ml-2 text-sm text-red-500">
                            (Principal)
                          </span>
                        </h3>
                        {showAddParentForm && (
                          <button
                            type="button"
                            onClick={() => setShowAddParentForm(false)}
                            className="text-white flex items-center justify-center rounded-full h-10 w-10 bg-red-500 hover:bg-red-600 hover:text-white !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                        {/* {index > 0 && (
                          <button
                            type="button"
                            onClick={() => removeContact(index)}
                            className="text-red-600 hover:text-red-800 !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        )} */}
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
                        <div>
                          <label
                            htmlFor={`type`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Type de contact{" "}
                            <span className="text-red-500">*</span>
                          </label>
                          <select
                            id={`type`}
                            name="type"
                            required
                            value={formData.contacts.type}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          >
                            <option value="">Sélectionner</option>
                            <option value="pere">Père</option>
                            <option value="mere">Mère</option>
                            <option value="tuteur">Tuteur légal</option>
                            <option value="autre">Autre</option>
                          </select>
                        </div>
                        <div>
                          <label
                            htmlFor={`nom`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Nom <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id={`nom`}
                            name="nom"
                            required
                            value={formData.contacts.nom}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          />
                        </div>
                        <div>
                          <label
                            htmlFor={`postnom`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Post-Nom <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id={`postnom`}
                            name="postnom"
                            required
                            value={formData.contacts.postnom}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          />
                        </div>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
                        <div>
                          <label
                            htmlFor={`prenom`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Prénom <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id={`prenom`}
                            name="prenom"
                            required
                            value={formData.contacts.prenom}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          />
                        </div>
                        <div>
                          <label
                            htmlFor={`genre`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Genre <span className="text-red-500">*</span>
                          </label>
                          <select
                            id={`genre`}
                            name="genre"
                            required
                            value={formData.contacts.genre}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          >
                            <option value="">Sélectionner</option>
                            <option value="M">Masculin</option>
                            <option value="F">Feminin</option>
                          </select>
                        </div>
                      </div>

                      <div className="space-y-6">
                        <div>
                          <h3
                            className={`text-lg font-medium  ${
                              isDarkMode ? "text-gray-400" : "text-gray-600"
                            }`}
                          >
                            Adresse principale & Profession
                          </h3>
                          <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div className="sm:col-span-6">
                              <label
                                htmlFor="avenue"
                                className={`block text-sm font-medium ${
                                  isDarkMode ? "text-gray-400" : "text-600"
                                } `}
                              >
                                Avenue <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                name="avenue"
                                id="avenue"
                                required
                                value={formData.contacts.avenue}
                                onChange={handleContactsChange}
                                className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                                  isDarkMode
                                    ? "bg-[#0D1117] border-gray-700"
                                    : "bg-gray-50 border-gray-200"
                                }`}
                              />
                            </div>
                            <div className="sm:col-span-2">
                              <label
                                htmlFor="quartier"
                                className={`block text-sm font-medium ${
                                  isDarkMode ? "text-gray-400" : "text-600"
                                } `}
                              >
                                Quartier <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                name="quartier"
                                id="quartier"
                                required
                                value={formData.contacts.quartier}
                                onChange={handleContactsChange}
                                className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                                  isDarkMode
                                    ? "bg-[#0D1117] border-gray-700"
                                    : "bg-gray-50 border-gray-200"
                                }`}
                              />
                            </div>
                            <div className="sm:col-span-4">
                              <label
                                htmlFor="commune"
                                className={`block text-sm font-medium ${
                                  isDarkMode ? "text-gray-400" : "text-600"
                                } `}
                              >
                                Commune <span className="text-red-500">*</span>
                              </label>
                              <input
                                type="text"
                                name="commune"
                                id="commune"
                                required
                                value={formData.contacts.commune}
                                onChange={handleContactsChange}
                                className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                                  isDarkMode
                                    ? "bg-[#0D1117] border-gray-700"
                                    : "bg-gray-50 border-gray-200"
                                }`}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <div>
                            <label
                              htmlFor="ville"
                              className={`block text-sm font-medium ${
                                isDarkMode ? "text-gray-400" : "text-600"
                              } `}
                            >
                              Ville <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="ville"
                              id="ville"
                              value={formData.contacts.ville}
                              onChange={handleContactsChange}
                              className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700"
                                  : "bg-gray-50 border-gray-200"
                              }`}
                            />
                          </div>
                          <div>
                            <label
                              htmlFor="telephone"
                              className={`block text-sm font-medium ${
                                isDarkMode ? "text-gray-400" : "text-600"
                              } `}
                            >
                              Téléphone
                            </label>
                            <input
                              type="tel"
                              name="telephone"
                              id="telephone"
                              required
                              value={formData.contacts.telephone}
                              onChange={handleContactsChange}
                              className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                                isDarkMode
                                  ? "bg-[#0D1117] border-gray-700"
                                  : "bg-gray-50 border-gray-200"
                              }`}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        <div>
                          <label
                            htmlFor={`email`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Email
                          </label>
                          <input
                            type="text"
                            id={`email`}
                            name="email"
                            value={formData.contacts.email}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          />
                        </div>
                        <div>
                          <label
                            htmlFor={`profession`}
                            className={`block text-sm font-medium ${
                              isDarkMode ? "text-gray-400" : "text-600"
                            } `}
                          >
                            Profession <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            id={`profession`}
                            name="profession"
                            value={formData.contacts.profession}
                            onChange={handleContactsChange}
                            className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                              isDarkMode
                                ? "bg-[#0D1117] border-gray-700"
                                : "bg-gray-50 border-gray-200"
                            }`}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* <div>
                  <button
                    type="button"
                    onClick={addContact}
                    className="flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                  >
                    <i className="fas fa-plus mr-2"></i>
                    Ajouter un autre contact
                  </button>
                </div> */}
                <div
                  className={`fixed bottom-0 left-60 right-0 py-3 px-6 border-t ${
                    isDarkMode
                      ? "bg-[#0D1117] border-gray-700"
                      : "bg-white border-gray-200"
                  } flex justify-between items-center`}
                >
                  <button
                    type="button"
                    onClick={() => setActiveTab("coordonnees")}
                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                  >
                    Précédent
                  </button>
                  <div className="flex space-x-3">
                    <a
                      href="#"
                      data-readdy="true"
                      className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                    >
                      Annuler
                    </a>
                    {/* <button
                      type="button"
                      onClick={(e) => handleSubmit(e, true)}
                      className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 !rounded-button whitespace-nowrap"
                    >
                      Enregistrer & Ajouter un autre
                    </button> */}

                    {!showAddParentForm ? (
                      <button
                        onClick={() => {
                          //validate required filds
                          const { parent_id } = formData;
                          if (!parent_id) {
                            return showNotification(
                              "Veuillez sélectionner un parent",
                              "error"
                            );
                          }

                          handleCreateStudent();
                        }}
                        className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                      >
                        {mutationCreateStudentMeth2.isPending ? (
                          <span className="flex items-center justify-center">
                            <i className="fas fa-spinner fa-spin mr-2"></i>
                            Chargement...
                          </span>
                        ) : (
                          "Valider inscription"
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          //validate required filds
                          const {
                            nom,
                            postnom,
                            prenom,
                            type,
                            genre,
                            ville,
                            commune,
                            quartier,
                            avenue,
                            profession,
                          } = formData.contacts;
                          if (
                            !nom.trim() ||
                            !postnom.trim() ||
                            !prenom.trim() ||
                            !type.trim() ||
                            !genre.trim() ||
                            !ville.trim() ||
                            !commune.trim() ||
                            !quartier.trim() ||
                            !avenue.trim() ||
                            !profession.trim()
                          ) {
                            return showNotification(
                              "Veuillez compléter tous les champs obligatoires",
                              "error"
                            );
                          }

                          if (!!formData.adresse.telephone.trim()) {
                            validatePhoneNumber(
                              formData.adresse.telephone,
                              "contacts"
                            );
                          }
                          handleCreateStudentAndParent();
                          console.log(formData);
                        }}
                        className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 !rounded-button whitespace-nowrap"
                      >
                        {mutationCreateStudentMeth1.isPending ? (
                          <span className="flex items-center justify-center">
                            <i className="fas fa-spinner fa-spin mr-2"></i>
                            Chargement...
                          </span>
                        ) : (
                          "Valider inscription"
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};
export default NewStudent;
